module.exports = {"Any Location":"Any","Online":"Online","England":"EN","Scotland":"SS","Wales":"WA","Ireland":"IE","Northern Ireland":"ND","USA":"US","Spain":"ES"}


//////////////////
// WEBPACK FOOTER
// ./src/data/countries_filter.json
// module id = YQpx
// module chunks = 8